import cls from "./button.module.scss";
import { CircularProgress } from "@mui/material";

type LoadMoreProps = {
  children: any;
  onClick?: () => void;
  loading?: boolean;
  size?: "small" | "large";
};

export default function LoadMore({
  children,
  onClick,
  loading = false,
  size = "large",
}: LoadMoreProps) {
  return (
    <button
      type="button"
      className={`${cls.loadMore} ${size === "small" ? cls.small : cls.large}`}
      disabled={loading}
      onClick={onClick}
    >
      {loading ? <CircularProgress size={21} /> : children}
    </button>
  );
}
